<template>
  <v-flex xs12>
    <p v-html="question.QuestionText"></p>
  </v-flex>
</template>

<script>
export default {
  props: ['question'],
  data () {
    return {
      value: null
    }
  }
}
</script>

<style>
</style>
